<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div style="padding-left:30px;">
          <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="参与人员" name="tab06">
              <el-table ref="tabmemberList" :show-header="false" :data="memberList" row-class-name="tab-row-1" height="350px">
                <el-table-column label="姓名" prop="userName" width="90px" :show-overflow-tooltip="true" />
                <el-table-column label="单位名称" prop="danWeiMingCheng" width="200px" :show-overflow-tooltip="true" />
                <el-table-column label="部门" prop="buMen" width="100px" :show-overflow-tooltip="true" />
                <el-table-column label="科室" prop="keShi" width="100px" :show-overflow-tooltip="true" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="任务编辑" name="tab02">
              <el-table ref="taboperLogList" :data="operLogList" row-class-name="tab-row-1" height="350px">
                <el-table-column prop="operDateShow" width="92px" label="时间" align="center" />
                <el-table-column prop="operUserName" width="70px" :show-overflow-tooltip="true" label="操作者" align="center" />
                <el-table-column prop="content" min-width="120px" label="记录">
                  <template slot-scope="scope">
                    <span v-html="scope.row.operLog" />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="讨论跟进" name="tab03">
              <el-table ref="tabtimelineList" :show-header="true" :data="timelineList" row-class-name="tab-row-1" height="350px">
                <el-table-column prop="operDateShow" width="92px" label="时间" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.operationDatetime | dateFmt('{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="operationUserName" width="70px" :show-overflow-tooltip="true" label="人员" align="center" />
                <el-table-column prop="operationAction" width="70px" :show-overflow-tooltip="true" label="操作" />
                <el-table-column prop="operationDescribe" min-width="100px" label="内容">
                  <template slot-scope="scope">
                    <span v-html="scope.row.operationDescribe" />
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="附件" align="right">
                  <template slot-scope="scope">
                    <span v-for="(item,idx) in scope.row.tempFiles" :key="idx" style="float:right" @click="handleDownLoad(item)">
                      <el-tooltip :content="item.name" placement="top" effect="light">
                        <i class="el-icon-tickets" />
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="nodeStatusNewDictKey" width="120px" fixed="right" label="状态" align="center">
                  <template slot-scope="scope">
                    <span><span v-if="scope.row.isAuditing">(审)</span> {{ scope.row.nodeStatusNewDictKeyItemName }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="false" label="讨论" name="tab01">
              <el-table ref="tabdisList" :show-header="false" :data="disList" row-class-name="tab-row-1" height="350px">
                <el-table-column prop="disDateShow" width="92px" />
                <el-table-column prop="disUserName" width="50px" :show-overflow-tooltip="true" />
                <el-table-column prop="content" min-width="120px" :show-overflow-tooltip="true" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="日程" name="tab05">
              <el-table ref="tabtaskScheList" :data="taskScheList" row-class-name="tab-row-1" height="350px">
                <el-table-column prop="scheDateTimeStart" width="205px" label="时间" align="center">
                  <template slot="header">
                    <el-button type="success" size="mini" @click="handleAddSche">新增日程</el-button>
                  </template>
                  <template slot-scope="scope">
                    <span>{{ scope.row.scheDateTimeStart | dateFmt('{m}-{d} {h}:{i}') }} ~ {{ scope.row.scheDateTimeEnd | dateFmt('{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="operUserName" width="70px" :show-overflow-tooltip="true" label="执行者" align="center" />
                <el-table-column prop="scheName" min-width="100px" :show-overflow-tooltip="true" label="日程名称" />
                <el-table-column prop="scheOperDetail" min-width="100px" :show-overflow-tooltip="true" label="执行详细" />
                <el-table-column prop="scheStatusDictName" width="80px" label="状态" align="center" />
                <el-table-column prop="scheCompleteDT" width="92px" label="完成时间" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.scheCompleteDT | dateFmt('{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="附件">
                  <template slot-scope="scope">
                    <span v-for="(item,idx) in scope.row.workTaskFiles" :key="idx" @click="handleDownLoad(item)">
                      <el-tooltip :content="item.name" placement="top" effect="light">
                        <i class="el-icon-tickets" />
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column fixed="right" width="210px" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.isCanExec" type="success" size="mini" @click="handleExecSche(scope.row)">执行</el-button>
                    <el-button v-if="scope.row.isCanEdit" type="primary" size="mini" @click="handleEditSche(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.isCanEdit" type="danger" size="mini" @click="handleDelSche(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="附件" name="tab04">
              <el-form v-model="searchFileCond" inline>
                <el-form-item label="时间">
                  <el-date-picker v-model="searchFileCond.uploadTimeFr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable size="mini" @change="handleReflashTempfileList" />
                </el-form-item>
                <el-form-item label="~">
                  <el-date-picker v-model="searchFileCond.uploadTimeTo" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable size="mini" @change="handleReflashTempfileList" />
                </el-form-item>
                <el-form-item label="上传者">
                  <el-select v-model="searchFileCond.uploadUserId" clearable size="mini" @change="handleReflashTempfileList">
                    <el-option
                      v-for="item in ketiMemberList"
                      :key="item.userKey"
                      :label="item.userName"
                      :value="item.userKey"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="来源">
                  <el-select v-model="searchFileCond.fileType" clearable placeholder="请选择来源" size="mini" @change="handleReflashTempfileList">
                    <el-option v-for="item in getComboxData('D96')" :key="item.value" :value="item.value" :label="item.label" />
                  </el-select>
                </el-form-item>
                <el-form-item label="文件名">
                  <el-input v-model="searchFileCond.name" clearable size="mini" @change="handleReflashTempfileList" />
                </el-form-item>
              </el-form>
              <el-table ref="tabfujianList" :show-header="true" :data="tempfileList" row-class-name="tab-row-1" height="350px">
                <el-table-column prop="uploadTime" width="92px" label="时间" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.uploadTime | dateFmt('{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="uploadUser" width="70px" :show-overflow-tooltip="true" label="上传者" />

                <el-table-column prop="fileTypeName" width="80px" label="来源" />
                <el-table-column prop="comment" width="200px" label="名称" :show-overflow-tooltip="true" />
                <el-table-column prop="name" min-width="150px" label="文件" />
                <el-table-column prop="snowid" fixed="right" width="50px" label="下载" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-download" @click="handleDownLoad(scope.row)" />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

          </el-tabs>
        </div>
      </el-col>
      <el-col :span="24">
        <div style="display:none">
          <el-input v-model="disContent" placeholder="讨论" style="margin:0px 10px 0px 2px;">
            <el-button slot="append" :loading="loading" style="background-color:#409EFF;color:#FFF;margin-right:1px" icon="el-icon-position" @click="handleAddDis">发言</el-button>
            <el-button slot="append" :loading="loading" style="background-color:#409EFF;color:#FFF;" icon="el-icon-position" @click="handleAddNotice">提醒</el-button>
          </el-input>
        </div>
      </el-col>
    </el-row>

    <el-dialog width="30%" title="提醒任务参与者" :visible.sync="selMemShow" append-to-body>
      <el-table ref="tabSelMem" :data="taskMemberList.filter(x=>{return x.userIdentityKey})" height="300px">
        <el-table-column type="selection" />
        <el-table-column prop="keShi" label="科室" />
        <el-table-column prop="userName" label="姓名" />
      </el-table>
      <div class="dialog-footer">
        <el-button @click="handleCloseSelMem()">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirmSelMem()">确 定</el-button>
      </div>
    </el-dialog>
    <WorkTaskScheEdit ref="sche" :entity-id="scheId" :task-id="entityId" :module-code="moduleCode" :module-key="moduleKey" @save-success="handleScheSuccess" />
    <WorkTaskScheExec ref="exec" :entity-id="scheId" :task-id="entityId" :module-code="moduleCode" :module-key="moduleKey" @save-success="handleScheSuccess" />
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import config from '@/config'
import axios from 'axios'
import WorkTaskScheEdit from './WorkTaskScheEdit'
import WorkTaskScheExec from './WorkTaskScheExec'
export default {
  name: 'WorkTaskExtra',
  components: { WorkTaskScheEdit, WorkTaskScheExec },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateTimeFormat(val).substr(5, 11)
    }
  },
  props: {
    entityId: { type: Number, default: null },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null },
    taskMemberList: { type: Array, default: () => { return [] } }
  },
  data() {
    return {
      allComboxData: [],
      activeName: 'tab03',
      disContent: '',
      disList: [],
      operLogList: [],
      timelineList: [],
      tempfileList: [],
      taskScheList: [],
      memberList: [],
      selMemShow: false,
      loading: false,
      scheId: null,
      searchFileCond: {},
      ketiMemberList: []
    }
  },
  computed: {
    myHeader() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
      }
    }
  },
  mounted() {
    this.disContent = ''
  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D96').then(res => {
      that.allComboxData = res.data.result
    })
    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm(
      'api/services/app/Com/GetKetizuMember'
    ).then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    init() {
      this.handleReflashDisList()
      this.handleReflashOperLogist()
      this.handleReflashTimelineList()
      this.handleReflashTempfileList()
      this.handleReflashTaskScheist()
      this.handleReflashMemberList()
    },
    clearData() {
      this.disContent = ''
      this.disList = []
      this.operLogList = []
      this.timelineList = []
      this.tempfileList = []
      this.taskScheList = []
      this.memberList = []
    },
    /** 设置显示tab 父组件使用 */
    selTab(tab) {
      this.activeName = tab
      this.handleTabClick(tab)
    },
    handleTabClick(tab) {
      const { name } = tab
      if (name === 'tab01') {
        this.handleReflashDisList()
      } else if (name === 'tab02') {
        this.handleReflashOperLogist()
      } else if (name === 'tab03') {
        this.handleReflashTimelineList()
      } else if (name === 'tab04') {
        this.handleReflashTempfileList()
      } else if (name === 'tab05') {
        this.handleReflashTaskScheist()
      } else if (name === 'tab06') {
        this.handleReflashMemberList()
      }
    },
    /** 讨论列表 */
    handleReflashDisList() {
      return
      // const that = this
      // const loading = this.$loading(KxjCom.loadOptions)
      // const path = '/api/services/app/WorkEvent/GetWorkEventDisList'
      // pathReq
      //   .getList(path, { id: that.entityId })
      //   .then(res => {
      //     that.disList = res.data.result
      //     loading.close()
      //     this.$nextTick(_ => {
      //       this.$refs.tabdisList.bodyWrapper.scrollTop = this.$refs.tabdisList.$refs.bodyWrapper.scrollHeight
      //     })
      //   })
    },
    /** 参与人员 */
    handleReflashMemberList() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkTask/GetTaskMemberList'
      pathReq
        .getList(path, { taskId: that.entityId })
        .then(res => {
          that.memberList = res.data.result
          loading.close()
        })
    },
    /** 操作列表 */
    handleReflashOperLogist() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkEvent/GetWorkEventOperLogList'
      pathReq
        .getList(path, { id: that.entityId })
        .then(res => {
          that.operLogList = res.data.result
          loading.close()
          this.$nextTick(_ => {
            this.$refs.taboperLogList.bodyWrapper.scrollTop = this.$refs.taboperLogList.$refs.bodyWrapper.scrollHeight
          })
        })
    },
    /** 日程列表 */
    handleReflashTaskScheist() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkEvent/GetWorkTaskScheList'
      pathReq
        .getList(path, { id: that.entityId })
        .then(res => {
          that.taskScheList = res.data.result
          loading.close()
          this.$nextTick(_ => {
            this.$refs.tabtaskScheList.bodyWrapper.scrollTop = this.$refs.tabtaskScheList.$refs.bodyWrapper.scrollHeight
          })
        })
    },

    /** 跟进 */
    handleReflashTimelineList() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkEventTimeLine/GetWorkFollowList'
      pathReq
        .getList(path, { taskId: that.entityId })
        .then(res => {
          that.timelineList = res.data.result
          loading.close()
          this.$nextTick(_ => {
            this.$refs.tabtimelineList.bodyWrapper.scrollTop = this.$refs.tabtimelineList.$refs.bodyWrapper.scrollHeight
          })
        })
    },
    /** 附件列表 */
    handleReflashTempfileList() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkTaskTempFileAppServices/GetTaskAllFileLists'
      that.searchFileCond.ModuleCode = that.moduleCode
      that.searchFileCond.ModuleKey = that.moduleKey
      that.searchFileCond.TaskId = that.entityId
      pathReq
        .getList(path, that.searchFileCond)
        .then(res => {
          that.tempfileList = res.data.result
          loading.close()
          this.$nextTick(_ => {
            this.$refs.tabfujianList.bodyWrapper.scrollTop = this.$refs.tabfujianList.$refs.bodyWrapper.scrollHeight
          })
        })
    },
    /** 增加讨论 */
    handleAddDis() {
      const that = this
      that.loading = true
      if (!that.disContent) {
        this.$message.error('内容不能为空')
        return
      }
      const path = '/api/services/app/WorkTask/AddWorkEventDiscuss'
      const d = {
        Entity: {
          workEventKey: that.entityId,
          content: that.disContent
        },
        TempFiles: []
      }
      pathReq.dataUpdate(path, d).then(res => {
        that.disContent = ''
        that.handleReflashDisList()
        that.activeName = 'tab01'
      }).then(_ => {
        that.loading = false
      })
    },
    /** 提醒成员 */
    handleAddNotice() {
      if (!this.disContent) {
        this.$message.error('内容不能为空')
        return
      }
      this.selMemShow = true
    },
    /** 关闭人员选择 */
    handleCloseSelMem() {
      this.selMemShow = false
    },
    /** 确认人员选择 */
    handleConfirmSelMem() {
      const that = this
      that.loading = true
      var selectRow = this.$refs.tabSelMem.selection
      if (selectRow.length === 0) {
        this.$message.error('没有选择提醒成员')
        return
      }
      // 增加讨论
      this.handleAddDis()
      // 任务提醒
      var noticeMemData = {
        taskId: that.entityId,
        noticeList: that.$refs.tabSelMem.selection.map((item) => {
          return {
            ToUserId: item.userId,
            ToUserIdentityKey: item.userIdentityKey,
            Content: that.disContent
          }
        })
      }
      var path = '/api/services/app/WorkTask/DoNoticeMember'
      pathReq.dataUpdate(path, noticeMemData).then(res => {
        that.$notify({
          message: '提醒成功',
          type: 'success',
          duration: 2000
        })
      }).then(_ => {
        this.selMemShow = false
      })
    },
    /** 下载附件 */
    handleDownLoad(file) {
      const that = this
      const loading = that.$loading(KxjCom.loadOptions)
      const url = config.apiHost + '/api/WorkTaskFile/DownloadUserFile?id=' + file.snowid
      const h = that.myHeader
      that.dlProgress = 0
      axios({
        method: 'post',
        url: url,
        // data: { id: row.id },
        responseType: 'blob',
        headers: h,
        onDownloadProgress(progress) {
          that.dlProgress = Math.round(progress.loaded / progress.total * 100)
        }
      }).then((res) => {
        var content = res.data
        var blob = new Blob([content])
        var fileName = file.name // 要保存的文件名称
        if ('download' in document.createElement('a')) {
          // 非IE下载
          var elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }

        loading.close()
        this.$message.success('下载成功')
      }).catch(() => {
        loading.close()
      })
    },
    /** 新增日程 */
    handleAddSche() {
      this.scheId = null
      this.$refs.sche.show()
    },
    /** 修改日程 */
    handleEditSche(row) {
      this.scheId = row.id
      this.$refs.sche.show()
    },
    /** 删除日程 */
    handleDelSche(row) {
      // const that = this
      this.$confirm('确定要删除该日程吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var loading = this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/WorkTaskSche/DeleteWorkTaskSche'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          loading.close()
          this.handleReflashTaskScheist()
        })
      }).catch(() => {
      })
    },
    /** 执行日程 */
    handleExecSche(row) {
      this.scheId = row.id
      this.$refs.exec.show()
    },
    /** 新增或修改成功 */
    handleScheSuccess() {
      this.handleReflashTaskScheist()
    }

  }
}
</script>
<style lang="scss">
.tab-row-1{
  .el-table__cell{
    padding: 1px 0px !important;
    .cell{
      padding: 0px 2px !important;
    }
  };
}

.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

</style>
